const { transform } = require('./transform');

/**
 * RateStyle
 * @class
 */
class RateStyle {

  /**
   * @param _$el {HTMLElement}
   * @param _vals {object}
   */
   constructor(_$el, _vals) {
    this.$el  = _$el;
    this.vals = _vals;
  }

  /**
   * @param _rate {number}
   */
  set(_rate) {
    const vals_ = _.reduce(this.vals, (_memo, _vals, _name) => {
      _memo[_name] = this.getNextVal(_vals[0], _vals[1], _rate);
      return _memo;
    }, {});

    transform(this.$el, vals_);
  }

  /**
   * @private
   * @param _initVal {number}
   * @param _completeVal {number}
   * @param _rate {number}
   */
  getNextVal(_initVal, _completeVal, _rate) {
    return Math.round((_initVal + ((_completeVal - _initVal) * _rate)) * 100) / 100;
  }

}

/**
 * class exports
 */
module.exports = RateStyle;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/module/rate-style.js
 **/